import React, { useState } from "react";
import styled from "styled-components";

import typography from "../../theme/typography";

import TextButton from "../shared/TextButton";

const Page = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

const Background = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const Image = styled.img`
  position: relative;
  margin-top: 115px;
`;

const PlaceHolder = styled.div`
  width: 360px;
  height: 250px;
`;

const Text = styled.p`
  position: relative;
  width: 100%;
  height: 200px;
  margin-top: ${(props) => (props.hasImage ? "5px" : "293px")};
  color: ${(props) => props.theme.color.white};
  ${typography.mainText2};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonContainer = styled.div`
  position: absolute;
  bottom: 90px;
`;

const GamePageLayout = ({
  bg,
  onClickNext,
  img,
  rawContent,
  noButton,
  children,
}) => {
  const [loading, setLoading] = useState(true);
  return (
    <Page>
      <Background src={bg} alt="" />
      {img && <Image src={img} alt="" onLoad={() => setLoading(false)} />}
      {img && loading && <PlaceHolder />}

      {!rawContent && <Text hasImage={img}>{children}</Text>}
      {rawContent && children}

      {!noButton && (
        <ButtonContainer>
          <TextButton text="다음" onClick={onClickNext} />
        </ButtonContainer>
      )}
    </Page>
  );
};

export default GamePageLayout;
